import './index.css';
import Wrapper from './entry_points/wrapper';
import Player from './entry_points/player';
import Editor from './entry_points/editor';

import * as annotations from 'rendering/annotations';
import * as compositionInformation from 'constants/annotations';

export * from 'constants';
export * from 'constants/layout';
export * from 'configuration/defaults';
export const viewer = options => new Viewer(options);
export const player = options => new Player(options);
export const editor = options => new Editor(options);
export const wrapper = options => new Wrapper(options);
export const version = HAPYAK_VERSION;
export { annotations, compositionInformation }
export {
    generateCustomTagString,
    generateIFrameEmbedString
} from 'utilities/embed';